import { zeusApi } from 'src/store/api';

const extendedApi = zeusApi.injectEndpoints({
  endpoints: build => ({
    logout: build.mutation<void, void>({
      query: () => ({
        url: '/logout',
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const { useLogoutMutation } = extendedApi;
